import { OrderStatus, type Order } from '@src/domains/orders/types/order';

/** Statuses of an order the buyer can still take up: one to pay, or one waiting on the seller's confirmation. */
export const OPEN_ORDER_STATUSES = [OrderStatus.Created, OrderStatus.AwaitingConfirmation];

/** An awaiting-confirmation order is not payable yet, but it is still the buyer's open purchase. */
export const isOpenOrder = (order: Order): boolean =>
  order.isPayable || order.status === OrderStatus.AwaitingConfirmation;
